<template>
    <div>
        <div class="carousel-item" style="display: block" v-if="banner !== null">
            <img class="second-slide" :src="banner.images[0].image.path" alt="Second slide">
            <div class="container">
                <div class="carousel-caption text-center">
                    <h1>{{ banner.images[0].overlay_text }}</h1>

                    <p><a class="btn btn-lg btn-warning" :href="banner.images[0].href" role="button">{{ banner.images[0].overlay_link_text }}</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    import axios from 'axios';
    
    export default {
        data() {
            return {
                banner: null,
            };
        },
        mounted() {
            axios.get('/api/v1/banners/1/shuffle').then(response => {
               this.banner = response.data;
            });
        }
    }
</script>


// WEBPACK FOOTER //
// themes/ldc/assets/js/banners/Banners.vue